import { HttpOptions,} from './types';
const DEFAULT_HEADERS = {
  'Content-Type': 'application/x-protobuf',
  'Accept': 'application/json',
  'Content-Encoding': 'gzip',
};


/**
 * 将值转换为字符串 - 统一的参数值处理逻辑
 * 内部使用：core.ts, protobuf-degradation.ts
 */
function stringifyValue(value: unknown): string {
  if (typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean') {
    return String(value);
  } else if (typeof value === 'object') {
    return JSON.stringify(value);
  } else {
    return String(value);
  }
}

/**
 * 准备请求选项 - 统一处理所有参数准备逻辑
 * 输入：原始 url 和 options
 * 输出：处理后的 finalUrl 和 finalOptions
 */
function prepareOptions(url: string, options: HttpOptions = {}): {
  finalUrl: string;
  finalOptions: HttpOptions;
} {
  const {
    method = 'GET',
    headers = {},
    body,
    timeout = 30000,
    params,
  } = options;

  // 1. 准备URL和参数
  const { finalUrl, queryParams } = prepareUrlAndParams(url, method, params);

  // 2. 设置请求头
  const finalHeaders = { ...DEFAULT_HEADERS, ...headers }

  // 3. 处理请求体 - 用户指定的 body 优先级更高
  let requestBody = body;
  
  // 如果没有用户指定的 body，且是 POST 请求，且有 params，则使用 params 作为 body
  if (!requestBody && method !== 'GET' && queryParams) {
    requestBody = queryParams;
  }

  // 4. 构建最终的选项
  const finalOptions: HttpOptions = {
    method,
    headers: finalHeaders,
    body:requestBody,
    timeout,
  };

  return {
    finalUrl,
    finalOptions
  };
}


/**
 * 准备URL和参数
 */
function prepareUrlAndParams(
  url: string,
  method: string,
  params?: Record<string, unknown>
): { finalUrl: string; queryParams: string | undefined } {
  let finalUrl = url;
  let queryParams: string | undefined = undefined;

  if (params && Object.keys(params).length > 0) {
    const searchParams = new URLSearchParams();
    Object.entries(params).forEach(([key, value]) => {
      if (value !== undefined && value !== null) {
        console.log(`${key}:`, value);
        searchParams.append(key, stringifyValue(value));
      }
    });
    const encodedParamsStr = searchParams.toString();
    if (method === 'GET') {
      finalUrl = url + (url.includes('?') ? '&' : '?') + encodedParamsStr;
    } else {
      queryParams = encodedParamsStr;
    }
  }

  return { finalUrl, queryParams };
}


/**
 * 验证请求选项
 */
function validateOptions(url: string, options: HttpOptions): void {
  if (!url || typeof url !== 'string') {
    throw new Error('URL is required and must be a string');
  }

  const validMethods = ['GET', 'POST', 'PUT', 'DELETE', 'PATCH', 'HEAD', 'OPTIONS'];
  if (options.method && !validMethods.includes(options.method.toUpperCase())) {
    throw new Error(`Invalid HTTP method: ${options.method}`);
  }

  if (options.timeout !== undefined && (typeof options.timeout !== 'number' || options.timeout < 0)) {
    throw new Error('Timeout must be a positive number');
  }
}

export {
  validateOptions,
  prepareOptions
};
